"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fluxActions = require("flux-actions");

var _mapPayloadTo = _interopRequireDefault(require("redux-less/utils/mapPayloadTo"));

var _default = function _default(_ref) {
  var actionTypes = _ref.actionTypes,
      propertyPath = _ref.propertyPath;
  var propertyPathAsString = propertyPath.join("/");
  var propertyName = propertyPath.pop();
  return (0, _fluxActions.createAction)(actionTypes[propertyPathAsString], (0, _mapPayloadTo.default)(propertyPathAsString));
};

exports.default = _default;
module.exports = exports.default;